import React, {useState} from "react";
import Kidney from "../../../assets/images/organs/72x72/Kidney_Up_72x72.png";
import KidneyHover from "../../../assets/images/organs/72x72/Kidney_Over_72x72.png";

function KidneyIcon(props) {
    const [isHover, setIsHover] = useState(false);

    if (props.showHover) {
        return (
            <div 
                className={props.count ? "icon-container organ-count-wrapper" : "icon-container"}
                onMouseEnter={()=> setIsHover(true)}
                onMouseLeave={()=> setIsHover(false)}
            >
                <img src={isHover ? KidneyHover : Kidney} alt="Kidney Icon" className="organ-icon" />
                {props.count &&
                    <div className="organ-count kidney">
                        {props.count}
                    </div>
                }
            </div>
        );
    }
    else {
        return (<img src={Kidney} alt="Kidney Icon" className="organ-icon" />);
    }
}

export default KidneyIcon;